import { render, staticRenderFns } from "./DragAndDropMobile.vue?vue&type=template&id=01c79086&scoped=true"
import script from "./DragAndDropMobile.vue?vue&type=script&lang=js"
export * from "./DragAndDropMobile.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropMobile.vue?vue&type=style&index=0&id=01c79086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c79086",
  null
  
)

export default component.exports